<template>
	<div id="prelive" class="bg-white">
		<b-container class="py-md-5">
			<b-row align-v="center">
				<b-col 	cols="12"
						lg="auto"
						class="py-4"
						:class="preliveQa() ? 'mw-lg-50' : null">
					<div class="p-5 p-md-0 rounded" :class="[asset.text_color ? 'text-'+asset.text_color : 'text-dark']">
						<h3 v-html="makeBr(asset.title)"></h3>
						<p class="lead m-0 pt-4" v-html="makeBr(asset.description)" v-if="asset.description"></p>
						<div class="line pt-3" v-if="asset.description"></div>
						<p class="lead m-0 pt-3" v-html="makeBr(asset.prelive)" v-if="asset.prelive"></p>
						<countdown @cdStarting="cdStarts" class="pt-5 pt-lg-7" v-if="asset.is_countdown"></countdown>
					</div>
				</b-col>
				<b-col 	cols="12"
						lg="4"
						class="ml-auto mw-lg-50 pb-6 pr-0"
						v-if="preliveQa()">
					<Ask />
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
	import Countdown from '@/components/asset/Countdown.vue'
	import Ask from '@/components/asset/Ask.vue'
	export default {
		data() {
			return {
				starting: false
			}
		},
		computed: {
			asset() {
				return this.$store.getters.asset
			}
		},
		components: {
			Countdown,
			Ask
		},
		methods: {
			preliveQa() {
				if(this.asset.asset_qa && this.asset.asset_qa.enabled && this.asset.asset_qa.prelive) return true
				return false
			},
			makeBr(text) {
				return text.replace('\n', '<br>')
			},
			cdStarts(val) {
				this.starting = val
			}
		}
	}
</script>
